"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Slice = exports.Last = exports.First = exports.Current = exports.Distinct = exports.Flatten = exports.ForEach = exports.doProperIncludes = exports.doIncludes = exports.doContains = exports.IndexOf = exports.ToList = exports.SingletonFrom = exports.Filter = exports.Times = exports.doIntersect = exports.doExcept = exports.doUnion = exports.Exists = exports.List = void 0;
var expression_1 = require("./expression");
var builder_1 = require("./builder");
var util_1 = require("../util/util");
var comparison_1 = require("../util/comparison");
var List = /** @class */ (function (_super) {
    __extends(List, _super);
    function List(json) {
        var _this = _super.call(this, json) || this;
        _this.elements = (0, builder_1.build)(json.element) || [];
        return _this;
    }
    Object.defineProperty(List.prototype, "isList", {
        get: function () {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    List.prototype.exec = function (ctx) {
        return this.elements.map(function (item) { return item.execute(ctx); });
    };
    return List;
}(expression_1.Expression));
exports.List = List;
var Exists = /** @class */ (function (_super) {
    __extends(Exists, _super);
    function Exists(json) {
        return _super.call(this, json) || this;
    }
    Exists.prototype.exec = function (ctx) {
        var list = this.execArgs(ctx);
        // if list exists and has non empty length we need to make sure it isnt just full of nulls
        if (list) {
            return list.some(function (item) { return item != null; });
        }
        return false;
    };
    return Exists;
}(expression_1.Expression));
exports.Exists = Exists;
// Equal is completely handled by overloaded#Equal
// NotEqual is completely handled by overloaded#Equal
// Delegated to by overloaded#Union
function doUnion(a, b) {
    var distinct = doDistinct(a.concat(b));
    return removeDuplicateNulls(distinct);
}
exports.doUnion = doUnion;
// Delegated to by overloaded#Except
function doExcept(a, b) {
    var distinct = doDistinct(a);
    var setList = removeDuplicateNulls(distinct);
    return setList.filter(function (item) { return !doContains(b, item, true); });
}
exports.doExcept = doExcept;
// Delegated to by overloaded#Intersect
function doIntersect(a, b) {
    var distinct = doDistinct(a);
    var setList = removeDuplicateNulls(distinct);
    return setList.filter(function (item) { return doContains(b, item, true); });
}
exports.doIntersect = doIntersect;
// ELM-only, not a product of CQL
var Times = /** @class */ (function (_super) {
    __extends(Times, _super);
    function Times() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Times;
}(expression_1.UnimplementedExpression));
exports.Times = Times;
// ELM-only, not a product of CQL
var Filter = /** @class */ (function (_super) {
    __extends(Filter, _super);
    function Filter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Filter;
}(expression_1.UnimplementedExpression));
exports.Filter = Filter;
var SingletonFrom = /** @class */ (function (_super) {
    __extends(SingletonFrom, _super);
    function SingletonFrom(json) {
        return _super.call(this, json) || this;
    }
    SingletonFrom.prototype.exec = function (ctx) {
        var arg = this.execArgs(ctx);
        if (arg != null && arg.length > 1) {
            throw new Error("IllegalArgument: 'SingletonFrom' requires a 0 or 1 arg array");
        }
        else if (arg != null && arg.length === 1) {
            return arg[0];
        }
        else {
            return null;
        }
    };
    return SingletonFrom;
}(expression_1.Expression));
exports.SingletonFrom = SingletonFrom;
var ToList = /** @class */ (function (_super) {
    __extends(ToList, _super);
    function ToList(json) {
        return _super.call(this, json) || this;
    }
    ToList.prototype.exec = function (ctx) {
        var arg = this.execArgs(ctx);
        if (arg != null) {
            return [arg];
        }
        else {
            return [];
        }
    };
    return ToList;
}(expression_1.Expression));
exports.ToList = ToList;
var IndexOf = /** @class */ (function (_super) {
    __extends(IndexOf, _super);
    function IndexOf(json) {
        var _this = _super.call(this, json) || this;
        _this.source = (0, builder_1.build)(json.source);
        _this.element = (0, builder_1.build)(json.element);
        return _this;
    }
    IndexOf.prototype.exec = function (ctx) {
        var index;
        var src = this.source.execute(ctx);
        var el = this.element.execute(ctx);
        if (src == null || el == null) {
            return null;
        }
        for (var i = 0; i < src.length; i++) {
            var itm = src[i];
            if ((0, comparison_1.equals)(itm, el)) {
                index = i;
                break;
            }
        }
        if (index != null) {
            return index;
        }
        else {
            return -1;
        }
    };
    return IndexOf;
}(expression_1.Expression));
exports.IndexOf = IndexOf;
// Indexer is completely handled by overloaded#Indexer
// Delegated to by overloaded#Contains and overloaded#In
function doContains(container, item, nullEquivalence) {
    if (nullEquivalence === void 0) { nullEquivalence = false; }
    return container.some(function (element) { return (0, comparison_1.equals)(element, item) || (nullEquivalence && element == null && item == null); });
}
exports.doContains = doContains;
// Delegated to by overloaded#Includes and overloaded@IncludedIn
function doIncludes(list, sublist) {
    return sublist.every(function (x) { return doContains(list, x); });
}
exports.doIncludes = doIncludes;
// Delegated to by overloaded#ProperIncludes and overloaded@ProperIncludedIn
function doProperIncludes(list, sublist) {
    return list.length > sublist.length && doIncludes(list, sublist);
}
exports.doProperIncludes = doProperIncludes;
// ELM-only, not a product of CQL
var ForEach = /** @class */ (function (_super) {
    __extends(ForEach, _super);
    function ForEach() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ForEach;
}(expression_1.UnimplementedExpression));
exports.ForEach = ForEach;
var Flatten = /** @class */ (function (_super) {
    __extends(Flatten, _super);
    function Flatten(json) {
        return _super.call(this, json) || this;
    }
    Flatten.prototype.exec = function (ctx) {
        var arg = this.execArgs(ctx);
        if ((0, util_1.typeIsArray)(arg) && arg.every(function (x) { return (0, util_1.typeIsArray)(x); })) {
            return arg.reduce(function (x, y) { return x.concat(y); }, []);
        }
        else {
            return arg;
        }
    };
    return Flatten;
}(expression_1.Expression));
exports.Flatten = Flatten;
var Distinct = /** @class */ (function (_super) {
    __extends(Distinct, _super);
    function Distinct(json) {
        return _super.call(this, json) || this;
    }
    Distinct.prototype.exec = function (ctx) {
        var result = this.execArgs(ctx);
        if (result == null) {
            return null;
        }
        return doDistinct(result);
    };
    return Distinct;
}(expression_1.Expression));
exports.Distinct = Distinct;
function doDistinct(list) {
    var distinct = [];
    list.forEach(function (item) {
        var isNew = distinct.every(function (seenItem) { return !(0, comparison_1.equals)(item, seenItem); });
        if (isNew) {
            distinct.push(item);
        }
    });
    return removeDuplicateNulls(distinct);
}
function removeDuplicateNulls(list) {
    // Remove duplicate null elements
    var firstNullFound = false;
    var setList = [];
    for (var _i = 0, list_1 = list; _i < list_1.length; _i++) {
        var item = list_1[_i];
        if (item !== null) {
            setList.push(item);
        }
        else if (item === null && !firstNullFound) {
            setList.push(item);
            firstNullFound = true;
        }
    }
    return setList;
}
// ELM-only, not a product of CQL
var Current = /** @class */ (function (_super) {
    __extends(Current, _super);
    function Current() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Current;
}(expression_1.UnimplementedExpression));
exports.Current = Current;
var First = /** @class */ (function (_super) {
    __extends(First, _super);
    function First(json) {
        var _this = _super.call(this, json) || this;
        _this.source = (0, builder_1.build)(json.source);
        return _this;
    }
    First.prototype.exec = function (ctx) {
        var src = this.source.exec(ctx);
        if (src != null && (0, util_1.typeIsArray)(src) && src.length > 0) {
            return src[0];
        }
        else {
            return null;
        }
    };
    return First;
}(expression_1.Expression));
exports.First = First;
var Last = /** @class */ (function (_super) {
    __extends(Last, _super);
    function Last(json) {
        var _this = _super.call(this, json) || this;
        _this.source = (0, builder_1.build)(json.source);
        return _this;
    }
    Last.prototype.exec = function (ctx) {
        var src = this.source.exec(ctx);
        if (src != null && (0, util_1.typeIsArray)(src) && src.length > 0) {
            return src[src.length - 1];
        }
        else {
            return null;
        }
    };
    return Last;
}(expression_1.Expression));
exports.Last = Last;
var Slice = /** @class */ (function (_super) {
    __extends(Slice, _super);
    function Slice(json) {
        var _this = _super.call(this, json) || this;
        _this.source = (0, builder_1.build)(json.source);
        _this.startIndex = (0, builder_1.build)(json.startIndex);
        _this.endIndex = (0, builder_1.build)(json.endIndex);
        return _this;
    }
    Slice.prototype.exec = function (ctx) {
        var src = this.source.exec(ctx);
        if (src != null && (0, util_1.typeIsArray)(src)) {
            var startIndex = this.startIndex.exec(ctx);
            var endIndex = this.endIndex.exec(ctx);
            var start = startIndex != null ? startIndex : 0;
            var end = endIndex != null ? endIndex : src.length;
            if (src.length === 0 || start < 0 || end < 0 || end < start) {
                return [];
            }
            return src.slice(start, end);
        }
        return null;
    };
    return Slice;
}(expression_1.Expression));
exports.Slice = Slice;
// Length is completely handled by overloaded#Length
//# sourceMappingURL=list.js.map